<template>
  <div>
    <!-- 基础信息 -->
    <el-dialog :title="$t('message.modifyName')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="488px" center>
      <div class="content">
        <el-form :model="detail" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">

          <!-- 全名（真名 -->
          <el-form-item :label="$t('message.fullName')">
            <el-input v-model="detail.realname"></el-input>
          </el-form-item>

        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">{{
      $t("message.cancel")
    }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="save">{{
      $t("message.save")
          }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    detail: { type: Object },
  },
  data() {
    return {
      dialogVisible: false,
      days: "",
      rules: {
        realname: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    // 保存
    save() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.detail.user_id = this.detail.id;
          this.$api.clienteleApi.updateUserRealname(this.detail).then((res) => {
            this.$message.success(res.msg);
            this.dialogVisible = false;
            this.$parent.clientDetail();
          });
        }
      });
    },
  },
};
</script>

<style lang='scss' scoped>
.content {
  margin: 0px 15px;
  padding: 24px;
  background: #f8f8f8;
  border-radius: 8px;

  p {
    font-size: 16px;
    font-weight: bold;
    color: #333333;
    margin-bottom: 24px;
  }

  .row {
    margin-bottom: 24px;
  }

  /deep/.el-radio__input {
    transform: scale(1.5) !important;
  }
}
</style>